import { defaultDialogSetupBuilder } from '@/components/services/dialog/dialogSetup';

export default (invokeArgs = {}) => {
  const postfix = invokeArgs.amount > 1 ? 's' : '';
  const dialogSubject = `Combo-order${postfix}`;

  defaultDialogSetupBuilder(
    {
      isModalShown: true,
      confirmTitle: `Approve the ${dialogSubject}`,
      confirmText: `Are you sure you want to approve
<strong>${invokeArgs.amount}</strong> ${dialogSubject}? You will be able to undo this action.`,
      confirmBtnColor: 'invokedDialogGreen',
      confirmBtnText: `Approve ${dialogSubject} (${invokeArgs.amount})`,
      ...invokeArgs,
    },
  );
};
